import {useFetchCitizenships} from '@rocket-ui/lk-api';
import {useCallback, useMemo} from 'react';
import {mapCitizenshipsToRegistrationCountries, normalizeCitizenshipsResponse} from './mapCitizenships';
import type {RegistrationCountry} from './types';

type Options = {
	enabled?: boolean;
};

export const useRegistrationCountries = (searchQuery?: string, options?: Options) => {
	const trimmedSearch = searchQuery?.trim() ?? '';
	const fetchQuery = trimmedSearch ? {country_name: trimmedSearch} : undefined;

	const {data, isLoading, isFetching} = useFetchCitizenships(fetchQuery, {
		enabled: options?.enabled ?? true,
	});

	const countries = useMemo(
		() => mapCitizenshipsToRegistrationCountries(normalizeCitizenshipsResponse(data)),
		[data],
	);

	const getCountryByCode = useCallback(
		(oksmCode: string | null): RegistrationCountry | undefined => {
			if (!oksmCode) {
				return undefined;
			}

			return countries.find((country) => country.oksmCode === oksmCode);
		},
		[countries],
	);

	return {
		countries,
		isLoading,
		isFetching,
		getCountryByCode,
	};
};
